module.exports = __webpack_public_path__ + "static/media/office.f08e9f2b.svg";